import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Box, Typography, Button } from "@mui/material";
import Layout from "../../components/layout/Layout";
import PrizePot from "../../../components/prizePot/PrizePot";
import Image from "material-ui-image";
import sadBoyImage from "../../assets/images/boy-sad.png";
import stopBoyImage from "../../assets/images/boy-stop.png";
import boyIcon from "../../../assets/pointing-bubbles.png";
import { toast } from "react-toastify";
import SecurityIcon from "@mui/icons-material/Security";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import LaunchIcon from "@mui/icons-material/Launch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { v4 as uuidv4 } from 'uuid';

function Subscription() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [trxId, setTrxId] = useState("");

  // Generate UUID once on component mount
  useEffect(() => {
    const generatedUuid = uuidv4().replace(/-/g, "").slice(0, 25);
    setTrxId(generatedUuid);
    
    // Get user info from session storage
    // const userData = sessionStorage.getItem("ccAuth");
    // if (userData) {
    //   setUserInfo(JSON.parse(userData));
    // } else {
    //   // Redirect to login if no user info
    //   navigate("../logins");
    // }
  }, [navigate]);

  // Redirect URLs with auto-generated UUID and fixed trfsrc
  const redirectLinks = [
    {
      id: 1,
      title: "Evina Protection",
      description: "Secure checkout and fraud protection service",
      icon: <SecurityIcon className="card-icon" />,
      url: `http://checkout.mtn-ng.dcbprotect.com/v3/lp/mtn-ng/395/9ijakids-trivia-daily-rvh96?trfsrc=9ijakids&trxId=${trxId}`,
      color: "linear-gradient(135deg, #c4bd00ff 0%, #ffa200ff 100%)",
      btnText: "Subscribe via Evina"
    },
    {
      id: 2,
      title: "Mfilter Service",
      description: "Content filtering and parental control solution",
      icon: <FilterAltIcon className="card-icon" />,
      url: `http://mtn-nigeria-prod.mfilterit.org/sid/234102200006857?trfSrc=9ijakids&trxId=${trxId}`,
      color: "linear-gradient(135deg, #00dd6eff 0%, #13a100ff 100%)",
      btnText: "Subscribe via Mfilter"
    }
  ];

  // Handle card click redirect
  const handleCardClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // Handle logout
  const handleLogout = () => {
    sessionStorage.removeItem("ccAuth");
    sessionStorage.removeItem("displayName");
    localStorage.removeItem("user_passport");
    localStorage.removeItem("rememberMe");
    navigate("../logins");
  };

  return (
    <Layout>
      <Container>
        {/* Welcome Message */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "#333",
            mb: 1
          }}
        >
          Welcome{userInfo?.displayName ? `, ${userInfo.displayName}` : ''}!
        </Typography>
        
        <Typography
          variant="h6"
          align="center"
          sx={{
            color: "#F24444",
            fontWeight: 600,
            mb: 4
          }}
        >
          Subscription Required
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            color: "#707070",
            mb: 4,
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: 1.6
          }}
        >
          To continue enjoying our trivia quiz service, you need an active subscription. 
          Choose one of the subscription options below:
        </Typography>

        {/* Subscription Cards Section */}
        <Box className="subscription-cards-section" sx={{ mb: 6 }}>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#333",
              mb: 1
            }}
          >
            Choose Subscription Method
          </Typography>
          
          <Typography
            variant="body2"
            align="center"
            sx={{
              color: "#666",
              mb: 4
            }}
          >
            Click on any card to subscribe
          </Typography>
          
          <Box className="cards-container" sx={{ mt: 4 }}>
            {redirectLinks.map((card) => (
              <Box 
                key={card.id}
                className="subscription-card"
                onClick={() => handleCardClick(card.url)}
                sx={{ 
                  background: card.color,
                  cursor: 'pointer',
                  borderRadius: '16px',
                  padding: '24px',
                  color: 'white',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '220px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)'
                  },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'rgba(255, 255, 255, 0.3)'
                  }
                }}
              >
                <Box className="card-header" sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Box sx={{ 
                    fontSize: '2rem', 
                    mr: 2, 
                    opacity: 0.9,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {card.icon}
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 600, color: 'white', m: 0 }}>
                    {card.title}
                  </Typography>
                </Box>
                
                <Box className="card-body" sx={{ flexGrow: 1, mb: 3 }}>
                  <Typography variant="body2" sx={{ opacity: 0.9, lineHeight: 1.5 }}>
                    {card.description}
                  </Typography>
                </Box>
                
                <Box className="card-footer" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Box 
                    className="card-btn"
                    sx={{ 
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      background: 'rgba(255, 255, 255, 0.2)',
                      padding: '10px 20px',
                      borderRadius: '25px',
                      fontWeight: 500,
                      fontSize: '0.9rem',
                      transition: 'all 0.2s ease',
                      backdropFilter: 'blur(10px)'
                    }}
                  >
                    {card.btnText}
                    <LaunchIcon sx={{ fontSize: '1rem' }} />
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Logout Button */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="body2" sx={{ color: '#707070', mb: 2 }}>
            Not {userInfo?.displayName || 'you'}?
          </Typography>
          <Button
            variant="outlined"
            onClick={handleLogout}
            sx={{
              color: "#707070",
              borderColor: "#707070",
              "&:hover": {
                borderColor: "#F24444",
                color: "#F24444"
              }
            }}
          >
            Logout
          </Button>
        </Box>
      </Container>

      {/* Inline Styles for Responsive Grid */}
      <style jsx="true">{`
        .cards-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 24px;
          margin-top: 20px;
        }
        
        @media (max-width: 768px) {
          .cards-container {
            grid-template-columns: 1fr;
          }
        }
        
        @media (max-width: 480px) {
          .subscription-card {
            padding: 20px;
            min-height: 200px;
          }
        }
      `}</style>
    </Layout>
  );
}

export default Subscription;